function *generate () {
    let id = 0
    while(id < 1000) {
        yield id++
    }
    return id
}
const iterator = generate()
const state = {
    menu: [
        {
            menuId: iterator.next().value,
            selectedIcon: "merchant-a.png",
            title: "数据台",
            unselectedIcon: "merchant.png",
            url: '/databoard'
        },
        {
            menuId: iterator.next().value,
            selectedIcon: "merchant-a.png",
            title: "门店管理",
            unselectedIcon: "merchant.png",
            children: [
                {
                    menuId: iterator.next().value,
                    selectedIcon: "merchant-a.png",
                    title: "门店列表",
                    unselectedIcon: "merchant.png",
                    url: '/store/list'
                },
            ]
        },
        {
            menuId: iterator.next().value,
            selectedIcon: "merchant-a.png",
            title: "收支明细",
            unselectedIcon: "merchant.png",
            children: [
                {
                    menuId: iterator.next().value,
                    selectedIcon: "merchant-a.png",
                    title: "明细数据",
                    unselectedIcon: "merchant.png",
                    url: '/finance/bill'
                },
            ]
        },
        {
            menuId: iterator.next().value,
            selectedIcon: "merchant-a.png",
            title: "系统管理",
            unselectedIcon: "merchant.png",
            children: [
                {
                    menuId: iterator.next().value,
                    selectedIcon: "merchant-a.png",
                    title: "账号信息",
                    unselectedIcon: "merchant.png",
                    url: '/system/account'
                },
            ]
        },
    ]
}
const getters = {
    getMenu(state) {
        return state.menu
    }
}
const mutations = {

}

const actions = {
    
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}